import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { HomeNewComponent } from './components/pages/home/home.component';
import { homeComponent } from './components/pages/home/home.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';


const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // All other routes are handled by child modules (PagesModule)
  // Wildcard route MUST be last to catch any unmatched routes
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: false, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
